import React from "react";

const Pagination = ({ page, limit, total, onPageChange, showAlways = false }) => {
  const totalPages = Math.ceil(total / limit);

  if (!showAlways && totalPages <= 1) return null;

  const goToPage = (p) => {
    if (p >= 1 && p <= totalPages) {
      onPageChange(p);
    }
  };

  return (
    <div className="pagination_rounded text-center mt-4">
      <ul>

        {/* PREV BUTTON (icon) */}
        <li className={page === 1 ? "disabled" : ""}>
          <a
            style={{ cursor: page === 1 ? "not-allowed" : "pointer" }}
            onClick={() => goToPage(page - 1)}
            className="prev"
          >
            <img src="/img/back.svg" alt="prev" />
          </a>
        </li>

        {/* PAGE NUMBERS */}
        {[...Array(totalPages)].map((_, i) => (
          <li key={i} className={page === i + 1 ? "active" : ""}>
            <a onClick={() => goToPage(i + 1)} style={{ cursor: "pointer" }}>
              {i + 1}
            </a>
          </li>
        ))}

        {/* NEXT BUTTON (icon rotated using CSS) */}
        <li className={page === totalPages ? "disabled" : ""}>
          <a
            style={{ cursor: page === totalPages ? "not-allowed" : "pointer" }}
            onClick={() => goToPage(page + 1)}
            className="next"
          >
            <img
              src="/img/back.svg"
              alt="next"
            />
          </a>
        </li>

      </ul>
    </div>
  );
};

export default Pagination;
